import Source from '../../models/source';
import Track from '../../models/track';
import SoundCloudTrack from '../../models/track/soundCloudTrack';

/**
 * The soundcloud.com page for a library track, when it is a SoundCloud one.
 *
 * Tracks come out of the library as plain JSON, so this reads the property
 * SoundCloudTrack stored rather than testing the class. Older records - or
 * ones built from somewhere that did not set it - simply have no link.
 */
export function soundCloudPermalink(track: Track | undefined): string | undefined {
  if (!track || track.type !== Source.SoundCloud) {
    return undefined;
  }

  const url = (track as SoundCloudTrack).permalinkUrl;

  return typeof url === 'string' && url ? url : undefined;
}

/**
 * The "clearly visible backlink" the API terms ask for. A new tab, with no
 * opener: the SoundCloud page has no business with this window.
 */
export function openOnSoundCloud(url: string) {
  window.open(url, '_blank', 'noopener,noreferrer');
}
